<template>
  <v-dialog persistent v-model="opened" width="700">
    <v-card>
      <v-card-title>
        <span class="text-h5" style="word-break: break-word !important;"  >Провести рассылку на опрос</span>
        <v-spacer></v-spacer>
        <v-btn
            icon
            fab
            small
            @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text-h6" style="text-align: left">
        <v-textarea
            v-model="data.text"
            label="Текст приглашения на опрос"
        ></v-textarea>
        <v-alert type="info" outlined v-if="!invitation">
          Нажмите Enter, чтобы добавить новую почту
        </v-alert>
        <v-text-field
           class="flex-column"
            v-if="!invitation"
            v-model="emailInput"
            :rules="[emailRule]"
            hide-details="auto"
            label="Почты"
            @keydown.prevent.enter="addEmail"
            ref="emailInputField"
        >
          <template v-slot:append-outer>
            <div class="mt-3">
              <v-chip
                v-for="(email, index) in data.email_list"
                :key="index"
                close
                class="mr-2"
                @click:close="removeEmail(email)"
                color="primary"
                outlined
                small
              >
                {{ email }}
                <v-icon right small>mdi-email-outline</v-icon>
              </v-chip>
            </div>
          </template>
        </v-text-field>
        <span v-if="invitation">
          Рассылка будет произведена на почты, указанные в списке индивидуальных ссылок
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="applyDialog"
        >
          Отправить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NotifyAboutSurvey",
  props: {
    opened: Boolean,
    invitation: Boolean
  },
  data(){
    return {
      data: {
        text: undefined,
        email_list: [],
      },
      emailInput: '',
    }
  },
  computed: {
    emailRule() {
      return (value) => {
        if (!value) return true
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Неверный формат почты.'
      }
    }
  },
  methods: {
    closeDialog: function () {
      this.$emit('close', false)
    },
    applyDialog: function () {
      if(this.emailInput.trim()) this.addEmail();
      this.$emit('save', this.data);
    },
    addEmail() {
      const email = this.emailInput.trim();
      if (this.emailRule(email) !== true) {
        return;
      }

      if (this.data.email_list.includes(email)) {
        this.emailInput = '';
        return;
      }

      if (this.emailInput.trim().length === 0) {
        return;
      }

      this.data.email_list.push(email);
      this.emailInput = '';
    },
    removeEmail(email) {
      const index = this.data.email_list.indexOf(email)
      if (index > -1) {
        this.data.email_list.splice(index, 1)
      }
    }

  }
}
</script>

<style scoped>

</style>
